import React from 'react';
import { Navigate } from 'react-router-dom';
export default function PartnerFit() { return <Navigate to="/partners" replace />; }